import React from 'react';
import PropTypes from 'prop-types';
import { APP_BEYOND_URL } from '../../tracker.constants';
import { generateIframe } from '../utils/package-tracking-iframe';

export default class PackageTrackingIframeWithTrackingKey extends React.Component {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    match: PropTypes.shape({
      params: {
        trackingKey: PropTypes.string.isRequired
      }
    }).isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      trackingKey: props.match.params.trackingKey
    };
  }

  componentDidMount() {
    const { trackingKey } = this.state;
    generateIframe(trackingKey, `${APP_BEYOND_URL}/rastreador/${trackingKey}`);

    window.addEventListener('message', this.handleMessage);
  }

  handleMessage = event => {
    if (event.origin === APP_BEYOND_URL) {
      const { action, url } = event.data;
      if (action === 'exitByAppLoggiIframe' && url) {
        window.location.replace(url);
      }
      if (action === 'updateUrlWithoutTrackingKeyAppLoggiIframe' && url) {
        window.location.replace(url);
      }
    }
  };

  render() {
    return null;
  }
}

PackageTrackingIframeWithTrackingKey.displayName =
  'PackageTrackingIframeWithTrackingKey';
